@if (busy) {
  <div class="overlay">
    <div class="center">
      <mat-spinner>
      </mat-spinner>
    </div>
  </div>
}
<div class="flex-col w-100 mt-3 p-2">
  @if (editMode) {
    <form class="w-100 flex-row flex-wrap" [formGroup]="editForm">
      <div class="flex-col w-100 editor-container px-2 mb-5">
        <quill-editor class="w-100"  placeholder="Your text here..." formControlName="text" ></quill-editor>
        @if (editForm.get('text')!.errors?.['required']) {
          <mat-error>Text is required</mat-error>
        }
      </div>
    </form>
  }
  @else {
    <div class="w-100"  [innerHTML]="editForm.get('text')!.value" >
    </div>
  }
  <div class="flex-row space-around items-center w-100 mt-3 p-2">
    @if (canCustomize) {
      <button mat-flat-button class="w-50 mx-2" color="primary" (click)="onCustomizeClick()">Customize</button>
    }
    @if (canEdit) {
      <button mat-flat-button class="w-50 mx-2" color="primary" (click)="onCustomizeClick()">Edit</button>
    }
    @if (canDelete) {
      <button mat-flat-button class="w-50 mx-2" color="warn" (click)="onDeleteClick()" >Delete</button>
    }
    @if (canSave) {
      <button mat-flat-button class="w-50 mx-2" color="primary" (click)="onSaveClick()" >Save</button>
    }
    @if (canCancel) {
      <button mat-flat-button class="w-50 mx-2" color="primary" (click)="onCancelClick()" >Cancel</button>
    }
  </div>
</div>
